import React from "react";
import {
  TabStripTab,
  TabStripTabProps,
} from "@progress/kendo-react-layout";
import "@progress/kendo-react-intl";

interface TabStripTabCustomProps extends TabStripTabProps{   
    dataGroupId: string;
    children: React.ReactNode
}

export const TabStripTabCustom: React.FC<TabStripTabCustomProps> = (props) => {
    const {...rest } = props;
    return ( 
            <TabStripTab {...rest}>               
                    {props.children}                
            </TabStripTab> 
    );
};